import React from 'react'
import './Support.css'

const Support = () => {
  return (
    <main className="support-page">
      <div className="container">
        <div className="support-content">
          <h1>Any question or any issue?</h1>
          <p>Contact us at: <a href="mailto:contact@loomio.games">contact@loomio.games</a></p>
        </div>
      </div>
    </main>
  )
}

export default Support
